import Image from "next/image"
import { useContext, useRef } from "react"
import { isMobileContext } from "../../contexts/isMobileContext"
import Button from "../common/Button"
import { BASE_URL } from "../../utils/FetchData"
import { phaseColorContext } from "../../contexts/phaseColorContext"
import { useEffect } from "react"


const BuildingTypeCard = ({
	title,
	type,
	price,
	date,
	bedrooms,
	floor,
	area,
	cardData,
	Button_Text1,
	Button_Text2,
	description,
	businessProject
}) => {
	const { isMobile } = useContext(isMobileContext)
	const { phaseColor } = useContext(phaseColorContext)
	return (
		<div className={`building-card  ${businessProject ? "businessProject" : ""}`}>
			<div className={`card-img-container`}>
				<div className="card-img">
					{cardData &&
						<Image
							src={BASE_URL + (isMobile ? cardData?.Img_Mobile?.data?.attributes?.url : cardData?.Img_Desktop?.data?.attributes?.url)}
							alt="card-img"
							layout="fill"
							objectFit="cover"
						/>
					}
					<div className="overlay"></div>
				</div>
			</div>
			<div className="card-data">
				<h3 className={`${isMobile?'bold':'light'}`}>{title}</h3>
				<p>{description}</p>
				<div className="building-details">
					<div className="single-section">
						{cardData?.Building_Details?.map((cardItem, i) => (
							i < 3 &&
							<div className="single-data" key={i}>
								<div className="img-container">
									<Image
										src={BASE_URL + cardItem?.Icon?.data?.attributes?.url}
										alt="icon"
										layout="fill"
										objectFit="contain"
									/>
								</div>
								<span>{cardItem?.Text}</span>
							</div>

						))}
					</div>
					<div className="single-section">
						{cardData?.Building_Details?.map((cardItem, i) => (
							i >= 3 &&
							<div className="single-data" key={i}>
								<div className="img-container">
									<Image
										src={BASE_URL + cardItem?.Icon?.data?.attributes?.url}
										alt="icon"
										layout="fill"
										objectFit="contain"
									/>
								</div>
								<span>{cardItem?.Text}</span>
							</div>
						))}
					</div>
				</div>
				<div className="buttons-container">
					<div className="downloadBtn"
						onClick={() => {
							document.getElementsByClassName('enquiry-section')[0].scrollIntoView({ behavior: 'smooth' })
						}}
					>
						<Button text={Button_Text1} blackStyle phaseColor={phaseColor} />
					</div>
					<a className="downloadBtn" aria-label="pdf" target="_blank" rel="noopener noreferrer"
						href={BASE_URL + cardData?.Pdf?.data?.attributes?.url}
					>
						<Button text={Button_Text2} blackBorder />
					</a>
				</div>
			</div>
		</div>
	)
}

export default BuildingTypeCard
